import { render } from "./DeliveryEnd.vue?vue&type=template&id=27d54714"
import script from "./DeliveryEnd.vue?vue&type=script&lang=js"
export * from "./DeliveryEnd.vue?vue&type=script&lang=js"
script.render = render

export default script